import ModulesComponentList from '../ModulesComponentList';


const UserCreatedModulesList = ({modules, playVideoInModal}) => {
    return <ModulesComponentList modules={modules} playVideoInModal={playVideoInModal} moduleActions={['edit']} videoActions={['play', 'createQuestions']} enablePagination={true} />
}

export default UserCreatedModulesList;